import React, { useEffect } from "react";
import "../styles/Gallery.css";
import { motion } from "framer-motion";
import Parallax from "./Parallax";

// Swiper Imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";

// Swiper Styles
import "swiper/css";
import "swiper/css/effect-coverflow";

import p2 from "../assets/tt16.png";

/* Images */
import g1 from "../assets/tt17.png";
import g2 from "../assets/tt29.jpeg";
import g3 from "../assets/tt9.png";
import g4 from "../assets/tt28.jpeg";
import g5 from "../assets/tt15.png";
import g6 from "../assets/tt6.png";
import g7 from "../assets/tt20.png";
import g8 from "../assets/tt21.png";
import g9 from "../assets/tt3.png";
import g10 from "../assets/tt18.png";

const images = [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8 } }
};

const Gallery = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    document.title =
      "Luxury Tempo Traveller Gallery | Best Tempo Traveller in Mayiladuthurai | Maha Cabs";

    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute(
      "content",
      "Explore real images of luxury Tempo Traveller from Maha Cabs. Best Tempo Traveller in Mayiladuthurai for family trips, tours, airport transfers, and outstation travel across India."
    );

    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://mahacabs.co/gallery");

    const preload = document.createElement("link");
    preload.rel = "preload";
    preload.as = "image";
    preload.href = g1;
    document.head.appendChild(preload);

    const schemaScript = document.createElement("script");
    schemaScript.type = "application/ld+json";
    schemaScript.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "name": "Maha Cabs",
          "url": "https://mahacabs.co",
          "logo": "https://mahacabs.co/logo4.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+919486589488",
            "contactType": "Customer Service"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Maha Cabs - Tempo Traveller Service",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "State Bank Road, Near Vijaya Theater",
            "addressLocality": "Mayiladuthurai",
            "postalCode": "609001",
            "addressCountry": "IN"
          },
          "telephone": "+919486589488",
          "url": "https://mahacabs.co"
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://mahacabs.co" },
            { "@type": "ListItem", "position": 2, "name": "Gallery", "item": "https://mahacabs.co/gallery" }
          ]
        },
        {
          "@type": "ImageGallery",
          "name": "Maha Cabs Tempo Traveller Gallery",
          "description": "Luxury Tempo Traveller images for family trips, tours, and outstation travel across India.",
          "associatedMedia": images.map((img, index) => ({
            "@type": "ImageObject",
            "name": `Luxury Tempo Traveller ${index + 1}`,
            "contentUrl": img,
            "caption": "Luxury AC Tempo Traveller with comfortable seating and professional driver from Maha Cabs"
          }))
        }
      ]
    });
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
      document.head.removeChild(preload);
    };
  }, []);

  return (
    <>
      <section className="g-gallery-section">
        <motion.div
          className="g-section-right"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <div className="g-slider-wrapper">
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 2.5,
                slideShadows: false,
              }}
              modules={[Autoplay, EffectCoverflow]}
              className="g-swiper"
            >
              {images.map((img, index) => (
                <SwiperSlide key={index} className="g-slide">
                  <img
                    src={img}
                    alt={`Luxury Tempo Traveller ${index + 1} in Mayiladuthurai - Maha Cabs AC Tempo Traveller with comfortable seats and professional driver`}
                    loading="lazy"
                    title="Luxury Tempo Traveller by Maha Cabs"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </motion.div>
      </section>

      <Parallax
        backgroundImage={p2}
        title="Book Luxury Tempo Traveller"
        subtitle="Travel Across India"
      />
    </>
  );
};

export default Gallery;